<template>
  <div>
    <v-row class="categoryMain" justify="start">
      <v-col cols="12" sm="3" v-for="category in categories" :key="category.id">
        <img
          class="category-img"
          v-if="category.icon !== null && category.icon !== ''"
          :src="baseUrl + category.fullFilesDirectory"
          alt=""
        />
<!--        <img-->
<!--          class="back-category-img"-->
<!--          v-if="category.icon_back !== null && category.icon_back !== ''"-->
<!--          :src="baseUrl + category.fullFilesBackDirectory"-->
<!--          alt=""-->
<!--        />-->
        <router-link
          active-class="active"
          :to="$i18nRoute({ name: 'search-npa', query: { category: category.id } })"
          :key="category.id"
        >
          {{ category.transName }}
        </router-link>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CMS from '@/model/cms'

export default {
  props: {
    widget: Object
  },
  data: () => ({
    categories: [],
    baseUrl: process.env.VUE_APP_BACK_URL
  }),
  mounted() {
    CMS.getNpaCategories()
      .then((response) => {
        this.categories = response.data
      })
      .catch((error) => {
        //@todo ошибки
      })
  }
}
</script>
